import React, { useState } from "react";
import StripeButton from "./StripeButton";
import "../components/SelectPlan.css";
import badge from "../images/PDFImages/Presenting_a_private_collaboration_1.png";
// src\images\PDFImages\Presenting_a_private_collaboration_1.png
function SelectPlan(props) {
  const [Open, setOpen] = useState(false);
  const currentKey = props.currentKey;

  function OpenModal() {
    setOpen(true);
  }
  function handleClick(event) {
    // console.log(event.target.className);
    if (event.target.className === "backDrop") CloseModal();
  }
  function CloseModal(event) {
    setOpen(false);
  }

  if (Open)
    return (
      <div className="backDrop" onClick={handleClick}>
        <div className="choiceModal">
          <table className="subInfo">
            <tr>
              <th className="Header">Select your plan!</th>
            </tr>
            <tr>
              <td>
                QFP Score
                <div className="checkMark member">✓</div>
                <div className="checkMark guest">✓</div>
              </td>
            </tr>
            <tr>
              <td>
                Downloadable QFP Plan
                <div className="checkMark member">✓</div>
              </td>
            </tr>
            <tr>
              <td>
                Personalized Data DashBoard
                <div className="checkMark member">✓</div>
              </td>
            </tr>
            <tr>
              <td>
                Worksheets and planning tools
                <div className="checkMark member">✓</div>
              </td>
            </tr>
          </table>

          <div className="col col1 colShadow"></div>
          <div className="col col2 colShadow"></div>
          <div className="col col1" onClick={CloseModal}>
            <div className="colSub Header colTop textShadow"> Guest</div>
            <div className="colSub Header colBot">
              <div className="shiftText">
                <div className="textShadow"> Free</div>
              </div>
            </div>
          </div>
          <StripeButton
            UserID={props.UserID}
            ArrayIndex={props.currentProfileIdx}
            TimeStamp={currentKey}
            Mode={"payment"}
            Label={"Buy This Report ($25.00)"}
          >
            <img src={badge} className="priceDisplayDiscount" />
            <div className="col col2">
              <div className="colSub Header colTop textShadow"> Member</div>

              <div className="colSub Header colBot">
                <div className="shiftText">
                  <div className="textShadow priceDisplay">
                    was <span>$25</span>
                  </div>
                  <div className="discount textShadow">$6.25</div>
                  {/* <div className="miniText"> per report</div> */}
                </div>
              </div>
            </div>
          </StripeButton>
        </div>
      </div>
    );

  return (
    <div className="divButton" onClick={OpenModal}>
      {props.label}
    </div>
  );
}

export default SelectPlan;
